module.exports = __webpack_public_path__ + "img/eprice-green-rectangle-grid-button.851141b3.gif";